import i18n from '@/i18n';

/**
 * Відображення текстів із конфігів станцій (назви КТП/УЗЕ, номінали, підписи
 * креслення). Дані лишаються українськими — тут лише локалізація на виході:
 * для uk повертається рядок БЕЗ змін, для en — скорочення й одиниці англійською.
 * Позначення обладнання (T1.1, 45.U, 1.GB), IP та серійні номери не чіпаються.
 */
const EXACT: Record<string, string> = {
  'ЗРУ-10кВ': 'Indoor switchgear 10 kV',
  'РУ-10 кВ': 'Switchgear 10 kV',
  'ТЗ для EMS box, ред. 3.1, додаток Б': 'EMS box spec, rev. 3.1, appendix B',
};

export function cx<T extends string | null | undefined>(s: T): T {
  if (!s || i18n.language !== 'en') return s;
  const str = s as string;
  if (EXACT[str]) return EXACT[str] as T;
  let r = str
    .replace(/КТП/g, 'KTP')
    .replace(/УЗЕ/g, 'BESS')
    .replace(/ПС(?=[\s-]\d)/g, 'SS')
    .replace(/кВА/g, 'kVA')
    .replace(/МВА/g, 'MVA')
    .replace(/кВт/g, 'kW')
    .replace(/МВт/g, 'MW')
    .replace(/кВ(?![А-Яа-яІіЇїЄєҐґ])/g, 'kV')
    .replace(/(\d)\s*Вт/g, '$1 W')
    .replace(/(\d),(\d)/g, '$1.$2')
    .replace(/(\d) ?\s(\d{3})(?!\d)/g, '$1,$2');
  return r as T;
}
